module.exports = __webpack_public_path__ + "static/img/light1.8c72790a.png";